// src/pages/HomePage.js
import React from 'react';
import HeroCarousel from '../components/HeroCarousel';
import FeaturedProducts from '../components/FeaturedProducts';
import ForBusiness from '../components/ForBusiness'; // <-- 1. Importa el componente

const HomePage = () => {
  return (
    <div>
      <HeroCarousel />
      <FeaturedProducts />
      <ForBusiness /> {/* <-- 2. Añádelo aquí */}
    </div>
  );
};

export default HomePage;